module.exports = __webpack_public_path__ + "69c406d9d8c7318dcdac650605172a19.png";